{
  "$schema": "https://sifa.id/schemas/activity-verbs/v1.json",
  "version": "1.1.0",
  "updated": "2026-07-19",
  "defaultVerb": "created",
  "verbs": {
    "app.bsky.feed.post": "posted",
    "blue.flashes.feed.post": "posted",
    "social.psky.feed.post": "posted",
    "social.popfeed.feed.post": "posted",
    "social.popfeed.feed.note": "posted",
    "social.popfeed.feed.review": "reviewed",
    "buzz.bookhive.book": "reviewed",
    "fyi.unravel.frontpage.post": "posted",
    "forum.barazo.post": "posted",
    "app.bsky.feed.repost": "reposted",
    "com.whtwnd.blog.entry": "published",
    "site.standard.document": "published",
    "computer.aetheros.page": "published",
    "link.pastesphere.snippet": "published",
    "pub.leaflet.comment": "published",
    "id.sifa.profile.presentation": "presented",
    "id.sifa.profile.presentationDelivery": "presented",
    "id.sifa.endorsement": "endorsed",
    "sh.tangled.repo": "shipped",
    "sh.tangled.repo.issue": "shipped",
    "sh.tangled.repo.pull": "shipped",
    "app.sidetrail.trail": "shipped",
    "app.sidetrail.walk": "shipped",
    "social.colibri.membership": "joined",
    "community.lexicon.calendar.rsvp": "joined",
    "at.youandme.connection": "joined",
    "id.sifa.graph.connection": "joined"
  }
}
